import Layout from '@/components/Layout/Vanilla';
import Hero from '@/components/Hero';
import Section from '@/components/Section';
import CardGrid from '@/components/CardGrid';
import { fetchPage, gql } from '@/lib/graphcms';

export default function Academy({ page, entries }) {
  return (
    <Layout seo={page}>
      <Section>
        <Hero {...page} />

        <CardGrid
          entries={entries}
          linkSubpath="academy"
          truncatedText
          {...page}
        />
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { page, academyPosts, featuredAcademyPosts } =
    (await fetchPage(
      gql`
        fragment academyPostData on AcademyPost {
          id
          slug
          title
          subTitle
          coverImage {
            ...assetDataXL
          }
          authors {
            ...authorData
          }
          content
          externalUrl
          meta: seo {
            ...seoData
          }
          __typename
        }

        query academyPageQuery {
          page: page(where: { slug: "academy" }) {
            ...pageData # Fragment is inside the method
          }
          academyPosts: academyPosts(
            where: {
              content_not: null
              OR: [{ featured: false }, { featured: null }]
            }
            orderBy: createdAt_DESC
          ) {
            ...academyPostData
          }
          featuredAcademyPosts: academyPosts(where: { featured: true }) {
            ...academyPostData
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  const entries = [...featuredAcademyPosts, ...academyPosts];

  return {
    props: {
      preview,
      page,
      entries,
    },
    revalidate: 3600,
  };
};
